'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fas';
var iconName = 'candle-holder';
var width = 448;
var height = 512;
var ligatures = [];
var unicode = 'f6bc';
var svgPathData = 'M160 192c45.93 0 78-32.61 78-79.29C238 82.72 205.41 37.82 160 0c-45.62 38-78 82.84-78 112.71 0 46.68 32.07 79.29 78 79.29zm216 176c-39.7 0-72 32.3-72 72 0 8.46 1.73 16.46 4.42 24H16c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h360c39.7 0 72-32.3 72-72s-32.3-72-72-72zm0 96c-13.23 0-24-10.77-24-24s10.77-24 24-24 24 10.77 24 24-10.77 24-24 24zM256 256c0-17.67-14.33-32-32-32h-64v48c0 8.84-7.16 16-16 16s-16-7.16-16-16v-48H96c-17.67 0-32 14.33-32 32v176h192V256z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.faCandleHolder = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = ligatures;
exports.unicode = unicode;
exports.svgPathData = svgPathData;